<template>
  <div
    class="
      fixed z-50
      bg-black bg-opacity-60
      text-white
      top-2 inset-x-1/2 w-20
      transform -translate-x-1/2
      text-center rounded"
  >
    <span class="block sm:hidden">XS</span>
    <span class="hidden sm:block md:hidden">SM</span>
    <span class="hidden md:block lg:hidden">MD</span>
    <span class="hidden lg:block xl:hidden">LG</span>
    <span class="hidden xl:block 2xl:hidden">XL</span>
    <span class="hidden 2xl:block">2XL</span>
  </div>
</template>
<script>
export default {
  name: 'ResponsiveHUD',
};
</script>
